import Block from '@/layouts/game-settings/components/Block'
import DescBlock from '@/layouts/game-settings/components/DescBlock'
import { FieldGroup, ToastSeverity, useToast } from '@/ui'
import { Button, Input } from '@dashboard/ui'
import { useForm } from 'react-hook-form'
import { UpdateTomatoesVersionSchema } from '@/api/dashboard'
import { useTranslation } from 'react-i18next'
import { dashboardClient } from '@/api'

export const StoreSettingsForm = () => {
  const { t } = useTranslation()
  const showToast = useToast()

  const {
    register,
    handleSubmit,
    reset,
    formState: { isDirty },
  } = useForm<UpdateTomatoesVersionSchema>()

  const onDiscardClick = () => {
    reset()
  }

  const onSaveClick = async (data: UpdateTomatoesVersionSchema) => {
    await dashboardClient.v1.updateTomatoesVersion(data)
    showToast({ message: t('saved'), severity: ToastSeverity.success })
    reset({
      version: data.version,
    })
  }

  return (
    <DescBlock title={'Store settings'}>
      <Block className="flex flex-col gap-3">
        <FieldGroup label={'Store version for menu notifications for ALL PUBLISHED GAMES'}>
          <Input {...register('version')} />
        </FieldGroup>
        <div className="flex justify-end gap-2">
          {isDirty && (
            <Button variant="outline" color="secondary" size="sm" onClick={onDiscardClick}>
              {t('Discard')}
            </Button>
          )}
          <Button size="sm" disabled={!isDirty} onClick={handleSubmit(onSaveClick)}>
            {t('Save2')}
          </Button>
        </div>
      </Block>
    </DescBlock>
  )
}
